export default __webpack_public_path__ + "static/media/prize-cup.b8201ed6.png";